/**
 * 웹툰 공통 메타태그 설정
 * 웹툰 하위 모든 경로에서 공유하는 메타태그
 */
export function getWebtoonMetaInfo(route?: any) {
  const appName = process.env.VUE_APP_NAME || "";
  const endpoint = process.env.VUE_APP_ENDPOINT || "";

  // 기본적으로 사용될 OG 이미지 (빌드 시 webpack이 처리한 경로를 사용)
  let ogImage = process.env.VUE_APP_META_IMAGE || "";
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    ogImage = require("@/assets/webtoon/og_webtoon.jpg");
  } catch (e) {
    // 파일이 없으면 환경변수 사용
    ogImage = process.env.VUE_APP_META_IMAGE || "";
  }

  const ogTitle = "입주 전, 미리 만나는 스마트 홈의 일상.";
  const ogDescription = "웹툰으로 만나는 채들의 이야기, 기술이 삶이 되는 순간.";
  const keywords =
    "모바일하자, 사전점검, 입주점검, 채들, 이음, 하자관리, AI, AI하자분류, 하자접수, 입주예약, 사전점검체크리스트";

  // 기본 웹툰 메타태그 (목록 페이지)
  const baseMeta = {
    title: ogTitle,
    meta: [
      {
        name: "description",
        content: ogDescription,
      },
      {
        name: "keywords",
        content: keywords,
      },
      {
        property: "og:title",
        content: ogTitle,
      },
      {
        property: "og:url",
        content: `${endpoint}/webtoon`,
      },
      {
        property: "og:image",
        content: ogImage,
      },
      {
        property: "og:description",
        content: ogDescription,
      },
      {
        name: "twitter:title",
        content: ogTitle,
      },
      {
        name: "twitter:url",
        content: `${endpoint}/webtoon`,
      },
      {
        name: "twitter:description",
        content: ogDescription,
      },
    ],
  };

  // 통합 뷰어 페이지인 경우
  if (route && route.name === "webtoon-viewer") {
    return {
      title: ogTitle,
      meta: [
        // baseMeta에서 URL 관련 태그만 제외하고 복사
        ...baseMeta.meta.filter(
          (m) => m.property !== "og:url" && m.name !== "twitter:url"
        ),
        {
          property: "og:url",
          content: `${endpoint}/webtoon/viewer`,
        },
        {
          name: "twitter:url",
          content: `${endpoint}/webtoon/viewer`,
        },
      ],
    };
  }

  return baseMeta;
}
